<template>
  <v-row>
    <v-col
        cols="12"
    >
      <h3>
        Plusy
      </h3>

      <p>
        {{ Bilance.totalPluses|currency('€') }}

        <template
            v-if="Bilance.totalPlusesBank || Bilance.totalPlusesCash"
        >
          <br/>

          <small>
            <template
                v-if="Bilance.totalPlusesBank"
            >
              <v-icon
                  color="primary"
              >
                mdi-bank-transfer
              </v-icon>

              {{ Bilance.totalPlusesBank|currency('€') }}
            </template>

            <template
                v-if="Bilance.totalPlusesCash"
            >
              <v-icon
                  color="primary"
              >
                mdi-cash
              </v-icon>

              {{ Bilance.totalPlusesCash|currency('€') }}
            </template>
          </small>
        </template>
      </p>

      <IsEmptyHelper
          :value="Bilance.bilancePluses.length > 0"
          if-no="table"
          if-yes="p"
          :no-gutters="true"
      >
        <thead>
          <tr>
            <th
                width="2.5%"
            >
              <v-checkbox
                  v-model="all"
                  :dense="true"
                  hide-details="auto"
                  @change="(value) => {
                    ids = []

                    total = 0

                    if (value) {
                      Bilance.bilancePluses.forEach((_BilancePlus) => {
                        ids.push(_BilancePlus.id)

                        total += _BilancePlus.price
                      })
                    }
                  }"
              />
            </th>

            <th
                width="10%"
                align="left"
            >
              Dátum
            </th>

            <th
                width="70%"
                align="left"
            >
              Názov
            </th>

            <th
                width="10%"
                align="left"
            >
              Suma
            </th>

            <th
                width="7.5%"
                align="left"
            >
              Platba
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
              v-for="(_BilancePlus) in Bilance.bilancePluses"
              :key="_BilancePlus.id"
              valign="top"
          >
            <td>
              <v-checkbox
                  v-model="ids"
                  :value="_BilancePlus.id"
                  :dense="true"
                  hide-details="auto"
                  @change="() => {
                    if (ids.length === Bilance.bilancePluses.length) {
                      all = true
                    } else {
                      all = false
                    }

                    if (ids.includes(_BilancePlus.id)) {
                      total += _BilancePlus.price
                    } else {
                      total -= _BilancePlus.price
                    }
                  }"
              />
            </td>

            <td>
              <IsEmptyHelper
                  :value="_BilancePlus.paidAt"
                  if-no="span"
                  if-yes="span"
              >
                {{ _BilancePlus.paidAt|moment('DD.MM.YYYY') }}
              </IsEmptyHelper>
            </td>

            <td>
              {{ _BilancePlus.title }}
            </td>

            <td>
              {{ _BilancePlus.price|currency('€') }}
            </td>

            <td>
              <IsEmptyHelper
                  :value="_BilancePlus.pay"
                  if-no="span"
                  if-yes="span"
              >
                {{ payList[_BilancePlus.pay]?.text }}
              </IsEmptyHelper>
            </td>
          </tr>
        </tbody>

        <tfoot
            v-if="ids.length > 0"
        >
          <tr>
            <th
                align="left"
                :colspan="3"
            />

            <th
                align="left"
            >
              {{ total|currency('€') }}
            </th>

            <th
                align="left"
            />
          </tr>
        </tfoot>
      </IsEmptyHelper>
    </v-col>
  </v-row>
</template>

<script>
  import IsEmptyHelper from '@/components/_Part/_Helper/IsEmpty'

  export default {
    name: 'Pluses',
    props: [
      'Bilance'
    ],
    components: {
      IsEmptyHelper
    },
    data() {
      return {
        all: false,
        ids: [],
        total: 0
      }
    },
    computed: {
      payList: function () {
        return this.$store.state.core.Entity.BilancePlus?.pay
      }
    }
  }
</script>
